import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const FrontLayout = () => {
    /*** Return output ***/
    return (
        <div className="layout-front app-wrapper">
            <div className="container-sm app-content">
                <div className="row justify-content-md-center">
                    <div className="col-lg-5 col-md-6 col">
                        <Header />
                        <Outlet />
                        {/* Footer (legal links + cookie notice) must show for everyone,
                            including guest customers — GDPR requires it on public pages. */}
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
}


export default FrontLayout;